import React, { useState } from "react";
import DataGrid, {
  Column,
  Editing,
  Lookup,
  Button as DxButton,
} from "devextreme-react/data-grid";

const AssetIdNumberComponent = () => {
  const [dataSource, setDataSource] = useState([
  
  ]);

  const nameOptions = [
    { id: 'MN', text: "Static Char" },
    { id: 'GR' , text: "Group" },
    { id: "CT", text: "Category" },
    { id: "SB", text: "Sub-Category" },
    { id: "SR", text: "Seperator" },
  ];

  return (
    <div style={{ padding: "20px" }}>
      <DataGrid
        dataSource={dataSource}
        keyExpr="id"
        showBorders={true}
        columnAutoWidth={true}
      >
        <Editing
          mode="row"
          allowUpdating={true}
          allowDeleting={true}
          allowAdding={true}
        />

        <Column dataField="id" caption="ID" width={60} />

        {/* Dropdown column */}
        <Column dataField="name" caption="Name">
          <Lookup
            dataSource={nameOptions}
            valueExpr="id"
            displayExpr="text"
          />
        </Column>

        <Column dataField="assetId" caption="Asset ID" />

        {/* Action buttons */}
        <Column type="buttons" width={120}>
          <DxButton name="edit" />
          <DxButton name="delete" />
        </Column>
      </DataGrid>
    </div>
  );
};

export default AssetIdNumberComponent;
